import React, { useState, useEffect, useRef } from 'react';
import style from './css/hero.module.css';
import Typewriter from '../TypeWriterText/Typewriter';

import bg1 from '../../assets/coding-guy.webp';
import bg2 from '../../assets/digital-marketing.webp';
import bg3 from '../../assets/tech-girl.jpg';

const backgrounds = [bg1, bg2, bg3];

const Hero = () => {
  const [currentBg, setCurrentBg] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % backgrounds.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    handleSwipe();
  };

  const handleSwipe = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      // Swiped left
      setCurrentBg((prev) => (prev + 1) % backgrounds.length);
    }

    if (touchEndX.current - touchStartX.current > 50) {
      // Swiped right
      setCurrentBg((prev) => (prev - 1 + backgrounds.length) % backgrounds.length);
    }
  };

  return (
    <div
      className={style.heroSection}
      style={{ backgroundImage: `url(${backgrounds[currentBg]})` }}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <header className={style.heroContent}>
        <small className={style.heroTinyText}>Aptech trained over 7 million students worldwide</small>
        <h1 className={style.heroH1}>
          Unleash Your <br />
          <span className={style.orangeText}>
            <Typewriter text="Potential." />
          </span>
        </h1>
        <p className={style.heroMainText}>
          Being technologically literate empowers you to navigate an increasingly digital world and positions you for big opportunities in this modern day.
        </p>
      </header>
    </div>
  );
};

export default Hero;
